<template>
  <section class="text-center">
    <h3 class="mb-4">¿Está seguro de realizar esta acción?</h3>
    <TextButton :disabled="loading" :loading="loading" @click="confirmCancel"> Sí, continuar </TextButton>
  </section>
</template>

<script>
import TextButton from '@src/components/base/TextButton.vue'
import { DIALOG_TYPES } from '@src/plugins/dialog-types'

export default {
  components: { TextButton },

  data() {
    return {
      DIALOG_TYPES,
      loading: false,
    }
  },

  props: {
    onConfirm: { type: Function, default: null },
  },

  methods: {
    async confirmCancel() {
      this.loading = true
      await this.onConfirm()
      this.loading = false
    },
  },
}
</script>
